import { getLoanById, patchSignLoanLenderBorrowerContract } from '@nemuru-eng/js-api-client';
import { useParams } from 'react-router-dom';

import { UseDialogProps } from '@/components/shared/components/ConditionsSummary/LoanConditionsSummary/components/LenderApplications/components/LoanApplicationActionDialog/LoanApplicationActionDialog';
import { StandardActionDialog } from '@/components/shared/components/StandardActionDialog/StandardActionDialog';
import { Text } from '@/components/shared/components/Text';
import { useCache } from '@/hooks/requests/useCache';
import { useRequest } from '@/hooks/requests/useRequest';

interface SetContractSignedDialogProps {
  loanApplicationId: string;
  useDialogProps: UseDialogProps;
}

export const SetContractSignedDialog = ({ loanApplicationId, useDialogProps }: SetContractSignedDialogProps) => {
  const { request, loading } = useRequest();
  const { loanId } = useParams();

  if (!loanId) return null;

  const { revalidate } = useCache(getLoanById, { loanId });

  const setLoanLenderBorrowerContractSigned = async () => {
    await request(patchSignLoanLenderBorrowerContract, { id: loanApplicationId });
    await revalidate();
    useDialogProps.toggleDialog();
  };

  return (
    <StandardActionDialog
      titleTextElement={<Text tId={'SET_CONTRACT_SIGNED'} />}
      actionDescriptionTextElement={
        <Text tId={'ARE_YOU_SURE_YOU_WANT_TO_SET_LOAN_LENDER_BORROWER_CONTRACT_TO_SIGNED'} />
      }
      loading={loading}
      opened={useDialogProps.opened}
      setOpened={useDialogProps.setOpened}
      setActionDialogParams={undefined}
      actionButtonsArray={[
        {
          onClick: () => setLoanLenderBorrowerContractSigned(),
          buttonLabelTextId: 'SET_CONTRACT_SIGNED_BUTTON',
        },
      ]}
    />
  );
};
